import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DATA_SETUP_FEATURE_KEY, DataSetupState } from './data-setup.reducer';

// Lookup the 'DataSetup' feature state managed by NgRx
export const getDataSetupState = createFeatureSelector<DataSetupState>(DATA_SETUP_FEATURE_KEY);

export const getDataSetupLoaded = createSelector(getDataSetupState, (state: DataSetupState) => state.loaded);

export const getDataSetupError = createSelector(getDataSetupState, (state: DataSetupState) => state.error);

export const getDataSetup = createSelector(getDataSetupState, (state: DataSetupState) => state.dataSetup);
